import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const DropTrailerChip = ({ className }) => {
    return (
        <div
            className={cn(
                "inline-flex h-[20px] items-center justify-center rounded-[4px] bg-cm-p-container-orange px-[6px]",
                className
            )}
        >
            <span className="whitespace-nowrap text-center text-xs font-medium text-cm-p-on-container-orange">
                <TranslatedText>Drop trailer</TranslatedText>
            </span>
        </div>
    );
};
